import ProductItem from "./ProductItem"

function ProductList(props) {

    const { product, incrCount, decrCount, delProduct } = props

    return (
        <div className="main">
            <div className='product-list'>
                {product.map(elem => <ProductItem
                    key={elem.id}
                    id={elem.id}
                    name={elem.name}
                    price={elem.price}
                    count={elem.count}
                    incrCount={incrCount}
                    decrCount={decrCount}
                    delProduct={delProduct}
                />)}
            </div>
        </div>
    )
}

export default ProductList